import type { IconData } from '@stacksjs/iconify-core'

export const arrowRightCircle1Solid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M46.5 24C46.5 11.574 36.426 1.5 24 1.5S1.5 11.574 1.5 24S11.574 46.5 24 46.5S46.5 36.426 46.5 24m-22.353.353a.5.5 0 0 0 0-.707l-6.499-6.498c-.97-.97-1.169-2.486-.29-3.538c.701-.839 1.537-1.674 2.392-2.275c1.008-.709 2.302-.377 3.218.446c3.274 2.942 7.602 7.329 9.779 10.211c.92 1.218.92 2.797 0 4.015c-2.176 2.883-6.505 7.27-9.779 10.212c-.916.823-2.21 1.155-3.218.446c-.855-.601-1.69-1.436-2.392-2.275c-.879-1.052-.68-2.568.29-3.538z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default arrowRightCircle1Solid
